module.exports = __webpack_public_path__ + "static/media/2fc623a0-2ccc-4a2f-a2e6-1d481a8e2acd.5f92d883.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/2fc623a0-2ccc-4a2f-a2e6-1d481a8e2acd.jpg
// module id = 810
// module chunks = 0